import React from 'react'

import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'

import Loading from '~/components/Loading/Mentions'

interface Props {
  children: any
  numberResults: number
  query: string
  serviceFkey: string
  types: string[]
}

interface SearchQuery {
  context: {
    documents: RelayConnection<Playground.Document>
    pageInfo: {
      endCursor?: string | number
      hasNextPage: boolean
    }
    taggableEntities: Playground.TaggableEntity[]
  }
}

const SEARCH_QUERY = gql`
  query Search($cursor: String, $serviceFkey: String!, $query: String!, $first: Int!, $types: [String]) {
    context(fkey: $serviceFkey) {
      fkey
      documents(first: $first, query: $query, after: $cursor, types: $types) {
        edges {
          node {
            author
            documentDate
            id
            insertedAt
            status
            title
            coverImage
            type
            typeId
            updatedAt
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      taggableEntities(query: $query) {
        displayText
        typeFkey
        imageUrl
        type
      }
    }
  }
`

const Search = ({ children, numberResults, query, serviceFkey, types }: Props) => {
  const { data, error, loading, fetchMore } = useQuery<SearchQuery>(SEARCH_QUERY, {
    variables: {
      query,
      serviceFkey,
      first: numberResults,
      types: types,
    },
  })

  if (error) {
    return null
  }

  if (loading) {
    return <Loading />
  }

  return children(data, fetchMore)
}

Search.displayName = 'Search'

export default Search
